<template>
  <vx-card class="my-4">
    <vs-row class="flex-col md:flex-row"
      ><vs-col class="md:w-1/3 lg:w-1/6 h-48"
        ><div class="overflow-hidden rounded-lg assignment__img h-full">
          <img
            class="h-full w-full object-cover"
            :src="
              assignment.feedLibraryItem.imageUrl
                ? assignment.feedLibraryItem.imageUrl
                : randomFeedImage
            "
            :alt="assignment.feedLibraryItem.title"
            @error="randomFeedImage"
          /></div></vs-col
      ><vs-col class="md:w-2/3 lg:w-5/6 md:pl-8 flex flex-col justify-between">
        <div>
          <div
            class="flex items-center mt-2 lg:mt-0"
            v-if="assignment.assignedFromGtbrddUserId"
          >
            <div class="h-8 w-8 overflow-none mr-2" v-if="userName !== 'you'">
              <img
                class="w-full h-full object-cover rounded-full"
                :src="
                  userProfilePic
                    ? constants.s3Bucket +
                      '/editor/profile-pictures/' +
                      userProfilePic
                    : `https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                        userName,
                        userName
                      )}`
                "
              />
            </div>
            <div class="font-semibold text-lg text-black">
              Assigned By {{ userName }}
              {{ getAssignedUser(assignment.assignedFromGtbrddUserId) }}
            </div>
          </div>
          <div
            class="flex items-center mt-2 lg:mt-0"
            v-else-if="assignment.feedLibraryItem.assignedBy.type === 'user'"
          >
            <div class="h-8 w-8 overflow-none mr-2" v-if="userName !== 'you'">
              <img
                class="w-full h-full object-cover rounded-full"
                :src="
                  userProfilePic
                    ? constants.s3Bucket +
                      '/editor/profile-pictures/' +
                      userProfilePic
                    : `https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                        userName,
                        userName
                      )}`
                "
              />
            </div>
            <div class="font-semibold text-lg text-black">
              Assigned By {{ userName }}
              {{ getAssignedUser(assignment.feedLibraryItem.assignedBy._id) }}
            </div>
          </div>
          <div v-else></div>

          <div class="flex items-center text-clip text-clip-1">
            <div
              class="text-black text-2xl truncate grow mt-2 lg:mt-0"
              v-if="
                assignment.feedLibraryItem && assignment.feedLibraryItem.title
              "
            >
              {{ assignment.feedLibraryItem.title }}
            </div>

            <img
              @click.once="openLink(assignment.feedLibraryItem)"
              class="ml-3 mt-2 lg:mt-0 cursor-pointer"
              src="@/assets/images/icons/arrow-right-circle.svg"
              alt="right-arrow"
            />
          </div>

          <div
            class="text-lg gray-400 my-3 text-clip"
            v-if="
              assignment.feedLibraryItem &&
              assignment.feedLibraryItem.description &&
              typeof assignment.feedLibraryItem.description === 'string'
            "
          >
            {{ assignment.feedLibraryItem.description }}
          </div>

          <div
            class="text-lg gray-400 my-3"
            v-else-if="assignment.feedLibraryItem.description.length > 0"
          >
            <div
              v-for="(data, index) in assignment.feedLibraryItem.description"
              :key="index"
              v-html="data"
            ></div>
          </div>
        </div>
      </vs-col>

      <div
        class="w-full flex justify-center"
        v-if="assignment.libraryItemValidationData"
      >
        <div
          class="flex items-center justify-center w-full"
          v-if="assignment.feedLibraryItemStatus === 'done'"
        >
          <!-- qr scan -->
          <div
            class="w-full"
            v-if="
              assignment &&
              assignment.feedLibraryItemStatus === 'done' &&
              assignment.libraryItemValidationData.validationType ===
                'attendance' &&
              isUserValidated
            "
          >
            <div class="py-10 px-4 my-4 md:my-10 action__container">
              <div class="flex items-center justify-center">
                <img
                  style="
                    filter: drop-shadow(10px 10px 30px rgba(0, 16, 97, 0.2));
                  "
                  src="@/assets/images/icons/qr-code-dummy.svg"
                  alt="QR Code"
                />
              </div>

              <div class="action__container__remarks">
                <div class="text-center font-bold text-xl text-black">
                  QR Code
                </div>
                <div class="text-center text-lg" style="color: #787878">
                  QR Code scan time: {{ scanTime }}
                </div>
              </div>
            </div>

            <div class="flex flex-col md:flex-row items-center justify-between">
              <div class="text-lg md:text-left" style="color: #787878">
                A validation is submitted on this learning. You may review and
                release the learning experience to be claimed.
              </div>
              <!-- btns  -->
              <div class="action__container__buttons mt-4 md:mt-0">
                <button
                  class="decline__button px-3 py-2"
                  @click="
                    validateAssignment(
                      'DECLINED',
                      assignment.userData,
                      assignment.feedLibraryItem,
                      assignment.feedLibraryItemStatus
                    )
                  "
                >
                  <img
                    src="@/assets/images/icons/org-review/cross.svg"
                  />Decline
                </button>

                <button
                  class="approve__button px-3 py-2"
                  @click="
                    validateAssignment(
                      'ACCEPTED',
                      assignment.userData,
                      assignment.feedLibraryItem,
                      assignment.feedLibraryItemStatus
                    )
                  "
                >
                  <img src="@/assets/images/icons/org-review/tick.svg" />Accept
                </button>
              </div>
            </div>
          </div>

          <!-- quiz -->
          <div
            v-if="
              quizResultData &&
              quizResultData.quizPercent &&
              quizResultData.numOfCorrectQuestions >= 0 &&
              quizResultData.totalNumOfQuestions &&
              isUserValidated
            "
          >
            <div class="py-10 px-4 mt-16 mb-8 action__container">
              <div class="action__container__badges">
                <img
                  v-if="quizResultData.quizPercent <= 50"
                  class="bad__badge"
                  src="@/assets/images/icons/org-review/org-review-bad.svg"
                />

                <img
                  v-else-if="
                    quizResultData.quizPercent > 50 &&
                    quizResultData.quizPercent <= 75
                  "
                  class="avg__badge"
                  src="@/assets/images/icons/org-review/org-review-avg.svg"
                />

                <img
                  v-else-if="quizResultData.quizPercent >= 75"
                  class="good__badge"
                  src="@/assets/images/icons/org-review/org-review-good.svg"
                />
              </div>

              <div class="action__container__remarks">
                <h3>Test Completed!</h3>

                <p v-if="quizResultData.quizPercent <= 50" class="bad__remark">
                  That’s poor.
                  {{ assignment.userData.firstName }}
                  {{ assignment.userData.lastName }}
                  only got <br /><span
                    >{{ quizResultData.numOfCorrectQuestions }}/{{
                      quizResultData.totalNumOfQuestions
                    }}</span
                  >
                  answers correct.
                </p>
                <p
                  v-else-if="
                    quizResultData.quizPercent > 50 &&
                    quizResultData.quizPercent < 75
                  "
                  class="avg__remark"
                >
                  That’s fair.
                  {{ assignment.userData.firstName }}
                  {{ assignment.userData.lastName }}
                  got a<br /><span
                    >{{ quizResultData.numOfCorrectQuestions }}/{{
                      quizResultData.totalNumOfQuestions
                    }}</span
                  >
                  answers correct.
                </p>
                <p
                  v-else-if="quizResultData.quizPercent >= 75"
                  class="good__remark"
                >
                  That’s great.
                  {{ assignment.userData.firstName }}
                  {{ assignment.userData.lastName }}
                  got a<br /><span
                    >{{ quizResultData.numOfCorrectQuestions }}/{{
                      quizResultData.totalNumOfQuestions
                    }}</span
                  >
                  answers correct.
                </p>
              </div>
            </div>

            <div class="flex flex-col md:flex-row items-center justify-between">
              <div class="text-lg md:text-left" style="color: #787878">
                A validation is submitted on this learning. You may review and
                release the learning experience to be claimed.
              </div>
              <!-- btns  -->
              <div class="action__container__buttons">
                <button
                  class="decline__button px-3 py-2"
                  @click="
                    validateAssignment(
                      'DECLINED',
                      assignment.userData,
                      assignment.feedLibraryItem,
                      assignment.feedLibraryItemStatus
                    )
                  "
                >
                  <img
                    src="@/assets/images/icons/org-review/cross.svg"
                  />Decline
                </button>

                <button
                  class="approve__button px-3 py-2"
                  @click="
                    validateAssignment(
                      'ACCEPTED',
                      assignment.userData,
                      assignment.feedLibraryItem,
                      assignment.feedLibraryItemStatus
                    )
                  "
                >
                  <img src="@/assets/images/icons/org-review/tick.svg" />Accept
                </button>
              </div>
            </div>
          </div>

          <!-- upload -->
          <div
            v-if="
              assignment &&
              assignment.feedLibraryItemStatus === 'done' &&
              assignment.libraryItemValidationData.validationType ===
                'upload' &&
              isUserValidated
            "
          >
            <div
              class="py-10 px-4 mt-16 mb-8 action__container flex justify-center items-center"
            >
              <div class="w-1/2 h-1/2">
                <img
                  class="w-full h-full object-cover"
                  :src="documentUploaded"
                  alt=""
                />
              </div>
            </div>

            <div class="flex flex-col md:flex-row items-center justify-between">
              <div class="text-lg md:text-left" style="color: #787878">
                A validation is submitted on this learning. You may review and
                release the learning experience to be claimed.
              </div>
              <!-- btns  -->
              <div class="action__container__buttons">
                <button
                  class="decline__button px-3 py-2"
                  @click="
                    validateAssignment(
                      'DECLINED',
                      assignment.userData,
                      assignment.feedLibraryItem,
                      assignment.feedLibraryItemStatus
                    )
                  "
                >
                  <img
                    src="@/assets/images/icons/org-review/cross.svg"
                  />Decline
                </button>

                <button
                  class="approve__button px-3 py-2"
                  @click="
                    validateAssignment(
                      'ACCEPTED',
                      assignment.userData,
                      assignment.feedLibraryItem,
                      assignment.feedLibraryItemStatus
                    )
                  "
                >
                  <img src="@/assets/images/icons/org-review/tick.svg" />Accept
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- <div v-else class="flex items-center text-start py-3 px-2">
            <span>
              <img
                src="@/assets/images/icons/alert-circle.svg"
                class="w-6"
                alt=""
              />
            </span>
            <h5
              class="ml-2 text-left text-lg"
              style="color: #ff6e4f !important"
            >
              It appears that the item has not been marked as 'done'. Therefore,
              the item cannot be reviewed at this time.
            </h5>
          </div> -->
      </div>

      <div
        v-if="
          assignment && assignment.feedLibraryItemStatus === 'notInterested'
        "
        class="flex items-center justify-between mt-2 md:mt-5 w-full"
      >
        <div class="flex items-center py-3 px-2 item-notice--do">
          <h5 class="ml-2 text-left">
            This learning action is marked as 'Not Interested'.
          </h5>
        </div>
        <button
          class="acknowledge__button px-3 py-3"
          @click="
            validateAssignment(
              'DECLINED',
              reviewAssignment.users[currentSelectedUserIndex].userData,
              reviewAssignment.users[currentSelectedUserIndex],
              reviewAssignment.users[currentSelectedUserIndex]
                .feedLibraryItemStatus
            )
          "
        >
          Acknowledge
        </button>
      </div>

      <div
        v-if="assignment && assignment.feedLibraryItemStatus === 'do'"
        class="flex items-center py-3 px-2 item-notice--do mt-2 md:mt-5"
      >
        <h5 class="ml-2 text-left">
          This item is assigned to
          {{ assignment.userData.firstName }}
          {{ assignment.userData.lastName }}
          by <b>admin </b>and is in <b>'Not Started'</b> state.
        </h5>
      </div>

      <div
        v-if="
          assignment &&
          assignment.feedLibraryItemStatus === 'done' &&
          !isUserValidated &&
          assignment.libraryItemValidationData &&
          assignment.libraryItemValidationData.validationType
        "
        class="flex items-center py-3 px-2 item-notice--doing mt-2 md:mt-5"
      >
        <h5 class="ml-2 text-left">
          This learning action is marked 'Done'. A review will be queued for
          approval as soon as its validation is completed.
        </h5>
      </div>

      <div
        v-if="
          assignment &&
          assignment.feedLibraryItemStatus === 'done' &&
          !isUserValidated &&
          !assignment.libraryItemValidationData
        "
        class="flex items-center py-3 px-2 item-notice--doing mt-2 md:mt-5"
      >
        <h5 class="ml-2 text-left">
          This learning action is marked 'Done'. Add a Validation to confirm the
          learning to release learning experience points and possible rewards.
        </h5>
      </div>
    </vs-row>
  </vx-card>
</template>

<script>
import constants from "@/constants";

export default {
  data() {
    return {
      constants,
      routeToLink: false,
      userData: {},
      userProfilePic: "",
      userName: "",
      quizResultData: {},
      scanTime: "",
      isUserValidated: false,
    };
  },
  props: {
    assignment: {
      type: Object,
      required: true,
    },

    orgId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.getQrScanTime();
    this.getQuizResult();
    this.getDocument();
  },
  computed: {
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    loggedUserData() {
      return this.$store.state.users.data;
    },
  },
  methods: {
    getAssignedUser(id) {
      this.$store
        .dispatch("users/getAssignedUser", id)
        .then((res) => {
          this.userProfilePic = res.profilePictureUrl
            ? res.profilePictureUrl
            : "";
          if (
            res.firstName === this.loggedUserData.firstName &&
            res.lastName === this.loggedUserData.lastName
          ) {
            this.userName = "you";
          } else {
            this.userName = `${res.firstName} ${
              res.lastName ? res.lastName : ""
            }`;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    openLink(item) {
      let link = `https://library.getboarded.com/redirect-page?itemId=${
        item.itemId
      }&type=${item.type || item.itemType}&gbuid=${this.userData._id}&gborgid=${
        this.orgId
      }&redirectsourceid=ORG_REVIEW`;
      this.routeToLink = true;
      if (link && this.routeToLink) {
        window.open(link, "_blank");
        this.routeToLink = false;
      }
    },
    validateAssignment(status, currentUser, item) {
      event.stopPropagation();
      if (item.status === "do" || item.status === "doing") {
        this.$vs.notify({
          color: "warning",
          text: "It appears that the item has not been marked as 'done' by the user yet. Therefore, the item cannot be reviewed at this time.",
        });
      } else {
        this.routeToLink = false;
        const payload = {
          libraryItemIds: [item.itemId],
          reviewStatus: status,
          gtbrddOrganizationId: this.orgId,
          gtbrddUserId: currentUser._id,
          // xpValue: this.reviewAssignment.libraryItemValidationData.xpValue,
        };
        this.$store
          .dispatch("alex/reviewAssignment", payload)
          .then((res) => {
            if (res && res.message) {
              this.$vs.notify({
                // title: "Validation marked done",
                text: "Item reviewed successfully !",
                iconPack: "feather",
                icon: "icon-check-circle",
                color: "success",
              });

              this.$emit("acceptedAssignment", item.itemId);
            }
          })
          .catch((err) => {
            //console.log(err);
          });
      }
    },
    getQuizResult() {
      if (
        this.assignment &&
        this.assignment.feedLibraryItem &&
        this.assignment.libraryItemValidationData.validationType === "quiz"
      ) {
        const payload = {
          orgId: this.orgId,
          userId:
            this.assignment && this.assignment.userData
              ? this.assignment.userData._id
              : "",
          itemId: this.assignment.feedLibraryItem.itemId,
        };
        this.$store
          .dispatch("organization/fetchQuizResult", payload)
          .then((res) => {
            if (res && res.data) {
              if (res.data.quizComplete) {
                const quizPercent = (
                  (res.data.numOfCorrectQuestions /
                    res.data.totalNumOfQuestions) *
                  100
                ).toFixed(2);

                this.isUserValidated = true;

                this.quizResultData = {
                  quizPercent: quizPercent,
                  numOfCorrectQuestions: res.data.numOfCorrectQuestions,
                  totalNumOfQuestions: res.data.totalNumOfQuestions,
                };
              }
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      }
    },
    getQrScanTime() {
      if (
        this.assignment &&
        this.assignment.libraryItemValidationData.validationType ===
          "attendance"
      ) {
        this.scanTime = "";
        this.$store
          .dispatch("users/getAttendance", {
            organizationId: this.orgId,
            feedItemId: this.assignment.feedLibraryItem.itemId,
            userId: this.assignment.userData._id,
          })
          .then((res) => {
            if (res && res.data && res.data.validated_at) {
              const timestamp = new Date(res.data.validated_at);
              const userTimeZone =
                Intl.DateTimeFormat().resolvedOptions().timeZone;

              const options = {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                timeZone: userTimeZone,
              };
              const formattedDate = timestamp.toLocaleDateString(
                "en-US",
                options
              );
              this.scanTime = formattedDate;
              this.isUserValidated = true;
            }
          })
          .catch(() => {});
      }
    },
    getDocument() {
      if (
        this.assignment &&
        this.assignment.libraryItemValidationData.validationType === "upload"
      ) {
        const payload = {
          orgId: this.orgId,
          userId:
            this.assignment && this.assignment.userData
              ? this.assignment.userData._id
              : "",
          itemId: this.assignment.feedLibraryItem.itemId,
        };
        this.$store
          .dispatch("organization/fetchUploadedDocument", payload)
          .then((res) => {
            if (res && res.data && res.data.s3FilePath) {
              this.isUserValidated = true;
              this.documentUploaded = res.data.s3FilePath;
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../reviewBase.scss";

.text-clip {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 4;
  &-1 {
    -webkit-line-clamp: 2;
  }
}

.item-notice {
  &--do {
    background: #f044380a;
    border: 2px solid #f044381a;
    border-radius: 0.5rem;
    h5 {
      color: #f04438 !important;
    }
  }
  &--doing {
    background: #f293000f;
    border: 2px solid #f293001a;
    border-radius: 0.5rem;
    h5 {
      color: #f29300 !important;
    }
  }
}

.action__container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  border: 2px solid #eaecf0;
  border-radius: 0.75rem;
  gap: 2rem;

  &__badges {
    width: fit-content;
    place-self: center;

    img {
      width: 8rem;
      height: auto;
    }

    .good__badge {
      width: 10rem;
      height: auto;
    }
  }

  &__remarks {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: fit-content;
    place-self: center;

    h3 {
      color: #000;
      text-align: center;
      font-size: 1.25rem;
      font-weight: 700;
    }

    p {
      color: #787878;
      text-align: center;
      font-size: 1rem;
      font-weight: 400;

      span {
        font-size: 1rem;
        font-weight: 700;
      }
    }

    .bad__remark {
      span {
        color: #fb2e56;
      }
    }

    .avg__remark {
      span {
        color: #f36f0f;
      }
    }

    .good__remark {
      span {
        color: #12b76a;
      }
    }
  }

  &__buttons {
    width: fit-content;
    place-self: center;
    gap: 2rem;
    display: flex;
    flex-direction: row;

    button {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 1.25rem;
      gap: 0.8rem;
      color: #fff;
      text-align: center;
      font-weight: 600;

      img {
        height: auto;
      }
    }

    .decline__button {
      background-color: #fb2e56;
      border: none;
      cursor: pointer;
    }

    .approve__button {
      background-color: #12b76a;
      border: none;
      cursor: pointer;
    }
  }
}

.acknowledge__button {
  background-color: #d0d5dd;
  color: #667085;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
}
</style>
